export const LieutenantBagdgeIcon = ({ width = 12, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#F0DF9A" />
      <path
        d="M6.12176 4.26474L3 6.57143V4.26474L6.12176 2L9.28571 4.26474V6.57143L6.12176 4.26474Z"
        fill="#AB6E1F"
      />
      <path
        d="M6.12176 7.69334L3 10V7.69334L6.12176 5.4286L9.28571 7.69334V10L6.12176 7.69334Z"
        fill="#AB6E1F"
      />
    </svg>
  );
};

export const GeneralBadgeIcon = ({ width = 12, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#7E744D" />
      <path
        d="M6 1L7.12257 4.45492H10.7553L7.81636 6.59017L8.93893 10.0451L6 7.90983L3.06107 10.0451L4.18364 6.59017L1.24472 4.45492H4.87743L6 1Z"
        fill="#F4D169"
      />
    </svg>
  );
};

export const CaptainBadgeIcon = ({ width = 12, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#797979" />
      <path
        d="M6.09732 5.97248L2 9V5.97248L6.09732 3L10.25 5.97248V9L6.09732 5.97248Z"
        fill="#E4E4E4"
      />
    </svg>
  );
};

export const MentorBadgeIcon = ({ width = 12, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#CFCFCF" />
      <path
        d="M8.72727 3H4.09091C3.80158 3 3.5241 3.11493 3.31952 3.31952C3.11493 3.5241 3 3.80158 3 4.09091V9.81818C3 9.89051 3.02873 9.95988 3.07988 10.011C3.13103 10.0622 3.2004 10.0909 3.27273 10.0909H8.18182C8.25415 10.0909 8.32352 10.0622 8.37467 10.011C8.42581 9.95988 8.45455 9.89051 8.45455 9.81818C8.45455 9.74585 8.42581 9.67648 8.37467 9.62533C8.32352 9.57419 8.25415 9.54545 8.18182 9.54545H3.54545C3.54545 9.40079 3.60292 9.26205 3.70521 9.15976C3.80751 9.05747 3.94625 9 4.09091 9H8.72727C8.7996 9 8.86897 8.97127 8.92012 8.92012C8.97127 8.86897 9 8.7996 9 8.72727V3.27273C9 3.2004 8.97127 3.13103 8.92012 3.07988C8.86897 3.02873 8.7996 3 8.72727 3ZM7.90909 6.27273L7.03602 5.61818C7.01242 5.60048 6.98371 5.59091 6.9542 5.59091C6.9247 5.59091 6.89599 5.60048 6.87239 5.61818L6 6.27273V3.54545H7.90909V6.27273Z"
        fill="#007AFF"
      />
    </svg>
  );
};

export const CfoBadgeIcon = ({ width = 12, height = 12 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6" cy="6" r="6" fill="#EFEFEF" />
      <g transform="translate(2, 3)">
        <path
          d="M6 1.68989V1.5C6 0.645 4.71034 0 3 0C1.28966 0 0 0.645 0 1.5V2.86364C0 3.5758 0.894886 4.14171 2.18182 4.31114V4.5C2.18182 5.355 3.47148 6 5.18182 6C6.89216 6 8.18182 5.355 8.18182 4.5V3.13636C8.18182 2.43068 7.31523 1.86409 6 1.68989ZM1.63636 3.6433C0.968523 3.45682 0.545455 3.14966 0.545455 2.86364V2.38398C0.823636 2.58102 1.19625 2.73989 1.63636 2.84659V3.6433ZM4.36364 2.84659C4.80375 2.73989 5.17636 2.58102 5.45455 2.38398V2.86364C5.45455 3.14966 5.03148 3.45682 4.36364 3.6433V2.84659ZM3.81818 5.27966C3.15034 5.09318 2.72727 4.78602 2.72727 4.5V4.35784C2.81693 4.36125 2.90761 4.36364 3 4.36364C3.13227 4.36364 3.26148 4.3592 3.3883 4.3517C3.52918 4.40214 3.67268 4.44493 3.81818 4.47989V5.27966ZM3.81818 3.75852C3.5473 3.79854 3.27382 3.81848 3 3.81818C2.72618 3.81848 2.4527 3.79854 2.18182 3.75852V2.9475C2.45311 2.98285 2.72642 3.00039 3 3C3.27358 3.00039 3.54689 2.98285 3.81818 2.9475V3.75852ZM6 5.39489C5.45745 5.47443 4.90619 5.47443 4.36364 5.39489V4.58182C4.63484 4.61828 4.90818 4.6365 5.18182 4.63636C5.4554 4.63675 5.72871 4.61921 6 4.58386V5.39489ZM7.63636 4.5C7.63636 4.78602 7.2133 5.09318 6.54545 5.27966V4.48295C6.98557 4.37625 7.35818 4.21739 7.63636 4.02034V4.5Z"
          fill="#9A89E0"
        />
      </g>
    </svg>
  );
};

export const VerifiedBadgeIcon = ({ width = 20, height = 21 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 10.5C0 7.84784 1.05357 5.3043 2.92893 3.42893C4.8043 1.55357 7.34784 0.5 10 0.5C12.6522 0.5 15.1957 1.55357 17.0711 3.42893C18.9464 5.3043 20 7.84784 20 10.5C20 13.1522 18.9464 15.6957 17.0711 17.5711C15.1957 19.4464 12.6522 20.5 10 20.5C7.34784 20.5 4.8043 19.4464 2.92893 17.5711C1.05357 15.6957 0 13.1522 0 10.5ZM9.42933 14.78L15.1867 7.58267L14.1467 6.75067L9.23733 12.8853L5.76 9.988L4.90667 11.012L9.42933 14.78Z"
        fill="#007AFF"
      />
    </svg>
  );
};
